<!-- Mobile backdrop: closes the sidebar when tapping outside -->
<div *ngIf="isMobile && isMobileMenuOpen" class="fixed inset-0 bg-black/40 z-40" (click)="closeMobileMenu()"
  (keydown.esc)="closeMobileMenu()" role="button" tabindex="-1" aria-label="Close menu"></div>

<nz-layout class="h-full flex gap-3" *transloco="let t">
  <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" [nzBreakpoint]="'xl'"
    [nzCollapsedWidth]="130" class="rounded-sm my-2 py-6 xxl:min-w-[90rem]" [ngStyle]="isMobile ? {
      'position': 'fixed',
      'top': '0',
      'left': '0',
      'height': '100vh',
      'width': isMobileMenuOpen ? '220px' : '130px',
      'max-width': isMobileMenuOpen ? '220px' : '130px',
      'min-width': isMobileMenuOpen ? '220px' : '130px',
      'flex': isMobileMenuOpen ? '0 0 220px' : '0 0 130px',
      'z-index': '100',
      'transform': isMobileMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
      'transition': 'transform 0.3s ease, width 0.3s ease'
    } : {}">
    <div class="flex items-center justify-start px-4">
      <app-mb-logo size="small" />
    </div>

    <div class="border-0 px-3" [class.p-6]="isCollapsed && !isMobileMenuOpen">
      <ul nz-menu nzMode="vertical" style="border-right: transparent">
        <ng-container *ngFor="let item of menuItems">
          <ng-container *ngIf="hasVisibleChildren(item)">
            <li
              class="px-4 mt-12 mb-4 text-mbaza-gray border-0 text-left font-extrabold text-xs uppercase tracking-wider">
              {{ t(item.label) }}
            </li>
          </ng-container>

          <div *ngIf="hasChildren(item)">
            <ng-container *ngFor="let child of item.children">
              <li *appMbPermissionCheck="child.permissions ?? 'NO_PERMISSIONS'" nz-menu-item
                style="cursor: pointer; color: black" [routerLink]="child.route" (click)="closeMobileMenu()"
                (keydown.esc)="closeMobileMenu()" tabindex="0" [class.menu-item-active]="
                  child.key === 'complaints' && isComplaintsActive()
                " class="rounded-md text-black  text-sm py-3 px-4 hover:bg-mbaza-gray-light hover:font-semibold">
                <div class="flex space-x-3 items-center" [class.justify-center]="isCollapsed && !isMobileMenuOpen">
                  <img [src]="child.icon" [alt]="child.icon" [height]="isCollapsed && !isMobileMenuOpen ? 20 : 16"
                    [width]="isCollapsed && !isMobileMenuOpen ? 20 : 16" class="transition-discrete duration-300"
                    [class.mt-2]="isCollapsed && !isMobileMenuOpen" />
                  <span *ngIf="!isCollapsed || isMobileMenuOpen">{{ t(child.label) }}</span>
                </div>
              </li>
            </ng-container>
          </div>

          <!-- Direct menu items (without children) -->
          <li *ngIf="!hasChildren(item)" nz-menu-item style="cursor: pointer; color: black" [routerLink]="item.route"
            (click)="closeMobileMenu()" (keydown.esc)="closeMobileMenu()" tabindex="0"
            routerLinkActive="menu-item-active"
            class="rounded-md text-black hover:bg-mbaza-gray-light hover:font-semibold">
            <div class="flex space-x-3 items-center" [class.justify-center]="isCollapsed && !isMobileMenuOpen">
              <img *ngIf="item.icon" [src]="item.icon" [alt]="item.icon"
                [height]="isCollapsed && !isMobileMenuOpen ? 24 : 14"
                [width]="isCollapsed && !isMobileMenuOpen ? 24 : 14" class="transition-discrete duration-300"
                [class.mt-2]="isCollapsed && !isMobileMenuOpen" />
              <span *ngIf="!isCollapsed || isMobileMenuOpen">{{ item.label }}</span>
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
  </nz-sider>
  <nz-layout>
    <nz-header class="rounded relative  flex-wrap mr-2 mt-2 flex justify-between items-center">
      <div class="flex items-center justify-between px-4 mt-3">
        <div class="flex flex-row items-center gap-4">
          <button nz-button nzType="text" (click)="toggleCollapsed()" (keydown.enter)="toggleCollapsed()"
            (keydown.space)="toggleCollapsed()" tabindex="0" role="button" [attr.aria-label]="'Toggle sidebar'"
            nzSize="large" [ngStyle]="{ background: 'transparent' }">
            <nz-icon nzType="menu" nzTheme="outline" />
          </button>
          <app-language-switcher />
        </div>

        <div class="flex items-center justify-between absolute right-2 gap-4">
          <!-- Mentions bell: badge is fed by the cheap /notifications/mentions/unread-count poll -->
          <div *appMbPermissionCheck="'VIEW_NOTIFICATION'" class="flex items-center cursor-pointer"
            (click)="openNotificationsDrawer()" (keydown.enter)="openNotificationsDrawer()"
            (keydown.space)="openNotificationsDrawer()" tabindex="0" role="button"
            [attr.aria-label]="'Open notifications'">
            @if (unreadNotificationsCount > 0) {
            <nz-badge [nzCount]="unreadNotificationsCount" [nzOverflowCount]="99">
              <img [src]="ASSET_CONSTANTS.I_bell_filled" alt="bell" class="w-5 h-5" />
            </nz-badge>
            } @else {
            <img [src]="ASSET_CONSTANTS.I_bell" alt="bell" class="w-5 h-5" />
            }
          </div>
          <app-user-profile />
        </div>
      </div>
      <nz-drawer [nzClosable]="false" [nzWidth]="isMobile ? '90%' : isMedium ? '40%' : '25%'"
        [nzVisible]="isNotificationsDrawerVisible" [nzPlacement]="'right'" (nzOnClose)="closeNotificationsDrawer()">
        <ng-container *nzDrawerContent>
          <app-mb-notifications [handleClose]="closeNotificationsDrawer" #notifications />
        </ng-container>
      </nz-drawer>
    </nz-header>

    <nz-content class="max-sm:mx-2 sm:mr-2 max-h-[96vh] py-2 overflow-auto  mb-2 rounded">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>